import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  StyledModal,
  StyledModalHeader,
} from '../../../../common/form/FormElements.jsx';
import { IconButton } from '../../../../common/controls/Controls.jsx';
import { useTranslation } from 'react-i18next';
import { EditOutlined, EyeOutlined, PlusOutlined } from '@ant-design/icons';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { useNavigate } from 'react-router-dom';

const ResponseCollectionDetailView = ({
  collectionData,
  saveDraft,
  isLocked = false,
}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const responses = collectionData.responses || [];

  const navigate = useNavigate();
  const lockedTooltip = t(
    'Otázka už má zaznamenané odpovede, jej kolekciu odpovedí nie je možné zmeniť.',
  );

  return responses.length > 0 ? (
    <>
      <div className="icon-eye-wrapper">
        <IconButton
          tooltip={t('Zobraziť odpovede')}
          onClick={() => setVisible(true)}
          icon={<EyeOutlined />}
        />
      </div>
      <div className="icon-eye-wrapper">
        <IconButton
          tooltip={t('Editovať')}
          onClick={() => {
            saveDraft();
            navigate(
              `${routes.cmsResponseCollectionsEdit}/${collectionData.id}`,
            );
          }}
          icon={<EditOutlined style={{ color: isLocked ? 'gray' : '' }} />}
          disabled={isLocked}
          disabledTooltip={lockedTooltip}
        />
      </div>
      <div className="icon-eye-wrapper">
        <IconButton
          tooltip={t('Pridať kolekciu odpovedí')}
          onClick={() => {
            saveDraft();
            navigate(routes.cmsResponseCollectionsCreate);
          }}
          icon={<PlusOutlined style={{ color: isLocked ? 'gray' : '' }} />}
          disabled={isLocked}
          disabledTooltip={lockedTooltip}
        />
      </div>

      <StyledModal
        open={visible}
        centered
        closeable={false}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={() => setVisible(false)}
        onOk={() => setVisible(false)}
      >
        <StyledModalHeader>
          {collectionData.name} ({responses.length})
        </StyledModalHeader>
        <ol className="response-collection-preview-list">
          {responses.map(({ id, name }) => (
            <li key={id}>{name}</li>
          ))}
        </ol>
      </StyledModal>
    </>
  ) : null;
};

ResponseCollectionDetailView.propTypes = {
  collectionData: PropTypes.any,
  saveDraft: PropTypes.func,
  isLocked: PropTypes.bool,
};

export default ResponseCollectionDetailView;
